import React, { FC } from 'react';

import { FullScreenButton } from '../full-screen-button/full-screen-button';
import StyleTag from '../../../../shared/components/style-tag/style-tag';
import Font from '../../../../shared/components/font/font';
import { Nullable } from '../../../../shared/types/Typescript-utils';

interface IHeadProps {
  isFullscreen?: boolean;
  customCSS?: Nullable<string>;
  fontSecondaryFamily?: Nullable<string>;
  fontSecondaryUrl?: Nullable<string>;
  customFontSecondary?: Nullable<string>;
}

const Head: FC<IHeadProps> = ({
  isFullscreen,
  customCSS,
  fontSecondaryFamily,
  customFontSecondary,
  fontSecondaryUrl,
}) => {
  return (
    <>
      {isFullscreen ? <FullScreenButton /> : null}
      <StyleTag customCSS={customCSS} />
      <Font
        fontConfig={{
          ...(fontSecondaryFamily ? { fontFamily: fontSecondaryFamily } : {}),
          ...(customFontSecondary ? { customFontCSS: customFontSecondary } : {}),
          ...(fontSecondaryUrl ? { fontUrl: fontSecondaryUrl } : {}),
        }}
      />
    </>
  );
};

export default Head;
